import { ColorLiterals } from '../../../../../themes';
import { useTheme } from '../../../../../hooks/useTheme';

export const useButtonColors = (color: ColorLiterals | undefined) => {
  const theme = useTheme();

  if (!color) return { main: undefined, dark: undefined, light: undefined }; // color is always defined

  return (
    // @ts-expect-error - palette doesn't accept any string, but here is validated
    theme.palette[color] ?? {
      main: color,
      dark: color,
      light: color,
    }
  );
};
